import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { FlexColumn } from 'ui-components/components/flex/column';
import { Gap } from 'ui-components/components/flex/gap';
import { Checkbox } from 'ui-components/components/checkbox';
import { Text, TextType } from 'ui-components/components/text';
import { InlineMessage, INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';

import { getErrorMessage } from '../../../validation/utilities';
import type { ValidationError } from '../../../validation/validation-error';
import { messages } from '../messages';
import style from './auto-pay-acceptance-section.module.less';

type AutoPayAcceptanceSectionProps = {
  isAccepted: boolean;
  isDisabled: boolean;
  error?: ValidationError;
  onAcceptChange: (accepted: boolean) => void;
};

export const AutoPayAcceptanceSection = ({ isAccepted, isDisabled, error, onAcceptChange }: AutoPayAcceptanceSectionProps) => {
  const intl = useIntl();

  const handleChange = useCallback(() => {
    onAcceptChange(!isAccepted);
  }, [isAccepted, onAcceptChange]);

  const errorMessage = getErrorMessage(error);

  return (
    <FlexColumn gap={Gap.Space8}>
      <FlexColumn>
        <Checkbox checked={isAccepted} disabled={isDisabled} label={intl.formatMessage(messages.autoPayLabel)} onChange={handleChange} />
        {errorMessage && <InlineMessage type={INLINE_MESSAGE_TYPES.error}>{errorMessage}</InlineMessage>}
      </FlexColumn>

      <Text className={style.description} textType={TextType.Caption} value={messages.autoPayDescription} />
    </FlexColumn>
  );
};
